<section class="banner" aria-label="Destaques">
  <div class="banner-carousel carousel slide carousel-fade" (mouseenter)="pausarAutoplay()"
    (mouseleave)="retomarAutoplay()" (focusin)="pausarAutoplay()" (focusout)="retomarAutoplay()">
    <div class="carousel-inner">
      @for (slide of slides(); track slide.id; let i = $index) {
      <div class="carousel-item banner-item" [class.active]="i === indiceAtivo()">
        @if (!imagensComErro().has(slide.id)) {
        <picture>
          @if (slide.imagemMobile) {
          <source media="(max-width: 768px)" [attr.srcset]="slide.imagemMobile" />
          }
          <img class="banner-imagem" [ngSrc]="slide.imagem" fill [priority]="i === 0" alt=""
            (error)="registrarErroImagem(slide.id)" />
        </picture>
        }
        <div class="banner-scrim" aria-hidden="true"></div>
      </div>
      }
    </div>

    <app-redes-sociais class="banner-social"></app-redes-sociais>

    @if (slides().length > 1) {
    <button type="button" class="carousel-control-prev banner-seta banner-seta-anterior" (click)="anterior()"
      aria-label="Slide anterior">
      <i-lucide name="chevron-left" size="22"></i-lucide>
    </button>
    <button type="button" class="carousel-control-next banner-seta banner-seta-proxima" (click)="proximo()"
      aria-label="Próximo slide">
      <i-lucide name="chevron-right" size="22"></i-lucide>
    </button>

    <div class="carousel-indicators banner-indicadores" role="tablist" aria-label="Selecionar slide">
      @for (slide of slides(); track slide.id; let i = $index) {
      <button type="button" class="banner-indicador" [class.active]="i === indiceAtivo()" (click)="irPara(i)" role="tab"
        [attr.aria-selected]="i === indiceAtivo()" [attr.aria-label]="'Ir para o slide ' + (i + 1)"></button>
      }
    </div>
    }
  </div>
</section>
